import { topicTags } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-cinema-bg">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">热门话题</h2>
          <p className="text-sm text-cinema-muted">大家都在讨论的影视热点</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((topic, i) => (
            <a
              key={i}
              href="#ranking"
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-300 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-cinema-accent/10 border-cinema-accent/30 hover:bg-cinema-accent/20 hover:border-cinema-accent/50'
                  : 'bg-cinema-card border-cinema-border hover:border-cinema-gold/30 hover:bg-cinema-card-hover'
              }`}
            >
              {topic.hot && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-fill text-cinema-accent text-xs"></i>
                </div>
              )}
              <span className={`text-sm ${topic.hot ? 'text-cinema-accent font-semibold' : 'text-cinema-text-dim'} group-hover:text-white transition-colors`}>
                #{topic.tag}
              </span>
              <span className="text-xs text-cinema-muted">{topic.count}讨论</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}